import PythonApi from '@/services/PythonApi';

export default {
  async getAlertDetails(cowID, payload){
    const params = new URLSearchParams();
    Object.keys(payload).forEach((key) => {
      if (payload[key])
        params.append(key, payload[key])
    })
    return PythonApi().get(`alert-details/${cowID}`, params);
  },
};



// WEBPACK FOOTER //
// ./src/services/AlertDetailsService.js